import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#264D50',        // Deep teal — main brand
        secondary: '#B69146',      // Golden sand — accent warmth
        accent: '#3C91E6',         // Blue accent — for links/info
        background: '#F8FAF9',     // Soft off-white background
        surface: '#FFFFFF',        // Card and modal background
        border: '#D9E0DD',         // Subtle gray-green border
        success: '#2E7D32',        // Calm forest green
        info: '#0288D1',           // Professional blue
        warning: '#E7B10A',        // Golden amber
        error: '#C44536',          // Modest red
        textPrimary: '#1E2A23',    // Deep charcoal
        textSecondary: '#5C6B63',  // Muted olive-gray
        primaryDark: '#1A3638',    // Darker shade of primary
        secondaryDark: '#8B6C2E',  // Darker shade of secondary
        primaryLight: '#3E6B6F',   // Lighter teal
        secondaryLight: '#D4B773', // Lighter gold
        highlight: '#D17E35',      // Warm burnt orange (for call-to-action)
        mutedAccent: '#6AA8A0',    // Soft teal tint (hover/secondary)
        innerBackground: '#F2F9F3'
      },
    },
  },
}

export default new Vuetify(opts)